import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthStore, startGuestSession } from "@/stores/authStore";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Typography } from "@/components/ui/typography";
import ThemeToggle from "@/components/ui/ThemeToggle";

export default function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionExpired = searchParams.get("expired") === "1";
  const user = useAuthStore((s) => s.user);
  const [guestLoading, setGuestLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/", { replace: true });
  }, [user, navigate]);

  const handleGoogleLogin = () => {
    window.location.href = `${import.meta.env.VITE_API_BASE ?? ""}/api/auth/google`;
  };

  const handleGuest = async () => {
    setGuestLoading(true);
    const ok = await startGuestSession();
    if (!ok) setGuestLoading(false);
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-background px-4">
      <div className="absolute right-4 top-4">
        <ThemeToggle />
      </div>

      <div className="w-full max-w-sm space-y-8">
        {/* ロゴ */}
        <div className="space-y-2 text-center">
          <Typography variant="h1" as="div">
            <span className="text-primary">DM</span>
            <span className="text-foreground"> Online</span>
          </Typography>
          <Typography tone="muted">身内専用 対戦テーブル</Typography>
        </div>

        {sessionExpired && (
          <Alert>
            <AlertDescription>
              セッションの有効期限が切れました。再度サインインしてください。
            </AlertDescription>
          </Alert>
        )}

        <Card>
          <CardContent className="space-y-4 py-2">
            <Typography tone="muted" className="text-center">
              Googleアカウントでログイン
            </Typography>
            <Button
              onClick={handleGoogleLogin}
              variant="outline"
              size="lg"
              className="w-full gap-3"
            >
              <GoogleIcon />
              Googleでログイン
            </Button>
            <Button
              onClick={handleGuest}
              disabled={guestLoading}
              size="lg"
              className="w-full"
            >
              ログインせずに始める
            </Button>
            <Typography variant="caption" tone="muted" className="text-center">
              ゲストのデッキはこのブラウザに紐づきます
            </Typography>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4" />
      <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853" />
      <path d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05" />
      <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335" />
    </svg>
  );
}
